import React, { ChangeEvent, useEffect, useState } from 'react';
import SearchBar from '../../../../components/SearchBar';
import { useZinantisMembers } from '../../../../contextsProperty/ContextZinantisMembers';
import Tooltip from '../../../../../muiComponents/Tooltip';
import IconButton from '../../../../../muiComponents/IconButton';
import TypeaheadCountries from './TypeaheadCountries';
import ConnectedFilter from './ConnectedFilter';
import useTranslate from '../../../../../customHooks/useTranslate';
import TypesFilter from './TypesFilter';

const MembersFiltersBar = () => {
    const translate = useTranslate();
    const { filters, updateFilters, resetFilters } = useZinantisMembers();

    const [areFiltersVisible, setAreFiltersVisible] = useState(false);

    useEffect(() => {
        if (!areFiltersVisible) {
            resetFilters();
        }
    }, [areFiltersVisible]);

    return (
        <>
            <div className='flex gap-5 flex-align-start width100perc'>
                <div className='flex-column gap-10 flex-grow padding-top4'>
                    <SearchBar
                        placeholder={translate('search')}
                        value={filters.name}
                        onChange={(e: ChangeEvent<HTMLInputElement>) =>
                            updateFilters('name', e?.target.value || '')
                        }
                        onClear={() => updateFilters('name', '')}
                    />
                    {areFiltersVisible ? (
                        <div className='flex gap-10 flex-align-center'>
                            <TypesFilter />
                            <TypeaheadCountries />
                            <ConnectedFilter />
                        </div>
                    ) : (
                        ''
                    )}
                </div>
                <Tooltip titleText={'show_filters'}>
                    <div>
                        <IconButton
                            iconName='Tune'
                            onClick={() => setAreFiltersVisible(prev => !prev)}
                        />
                    </div>
                </Tooltip>
            </div>
        </>
    );
};

export default MembersFiltersBar;
